import { SessionDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";
import { ApprovalStatus } from "@bcasmart/doxecure-commons/doxecureModelTypes";
import { SectionCategory, SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard, SessionFilter } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const ToBeApprovedDocumentsView = () => {
    const { connectedProfileId } = useAuthContext();
    const sessionFilter:SessionFilter = (session:SessionDto, _:SectionCategory): boolean => session.approvals?.findIndex(a => a.status === ApprovalStatus.ToApprove && a.approver.apid === connectedProfileId) === -1; // Do not show here, sessions to approve (already present in 'Parapheur')
    optlog(`+++ ToBeApprovedDocumentsView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents en attente d'approbation"
            emptyMessage="Pas de documents en attente d'approbation"
            category="to-be-approved"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver]} 
            sectionInfos={defaultSectionInformations} 
            sessionFilter={sessionFilter}
        />),
        false,
        "Impossible d'afficher la liste des documents en attente d'approbation car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;    
};
